import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabase';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import banner from '../assets/Banner.png'

function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (user) {
      fetchProfile();
    }
  }, [user]);

  const fetchProfile = async () => {
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .single();

      if (error) throw error;
      setProfile(data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  if (!user) {
    navigate('/login');
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col bg-primary-50">
      <Navigation />
      <div className="flex-grow pt-16 md:pt-20 mt-2 md:mt-5 mb-8">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            {/* Profile Card */}
            <div className="lg:col-span-3">
              <div className="bg-primary-extra rounded-lg shadow-sm p-6">
                <div className="flex flex-col items-center text-center">
                  {/* Profile Picture */}
                  <div className="relative mb-4">
                    <div className="w-24 h-24 rounded-full bg-primary-100 flex items-center justify-center overflow-hidden">
                      {profile?.profile_picture_url ? (
                        <img 
                          src={profile.profile_picture_url} 
                          alt="Profile" 
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                      )}
                    </div>
                  </div>

                  {/* Profile Info */}
                  <h2 className="text-lg font-semibold text-primary-text mb-1">
                    {profile ? `${profile.first_name} ${profile.last_name}` : 'Loading...'}
                  </h2>
                  <p className="text-primary-500 text-sm mb-2">
                    {profile?.current_subject || 'Subject not specified'}
                  </p>
                  <p className="text-primary-footerText text-sm mb-4">
                    @{profile?.current_institution || 'Institution not specified'}
                  </p>
                  <p className="text-primary-footerText text-xs mb-4">
                    Profile last updated - Today
                  </p>

                  {/* Update Profile Button */}
                  <button
                    onClick={() => navigate('/personal-information')}
                    className="w-full px-4 py-2 bg-primary-500 text-primary-50 rounded-md hover:bg-opacity-90 text-sm"
                  >
                    Update Profile
                  </button>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="lg:col-span-9 space-y-6">
              {/* Hero Banner */}
              <div className="relative h-48 md:h-64 rounded-lg overflow-hidden">
                <img
                  src={banner}
                  alt="Find your dream job"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Saved Jobs Section */}
              <div className="bg-primary-extra rounded-lg shadow-sm p-6">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-lg font-semibold text-primary-text">Your Saved jobs</h3>
                  <button className="text-primary-500 text-sm hover:underline">View All</button>
                </div>
                <div className="text-center py-8 text-primary-footerText">
                  No saved jobs yet
                </div>
              </div>

              {/* Recommended Jobs Section */}
              <div className="bg-primary-extra rounded-lg shadow-sm p-6">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-lg font-semibold text-primary-text">Recommended jobs for you</h3>
                  <button className="text-primary-500 text-sm hover:underline">View All</button>
                </div>
                <div className="text-center py-8 text-primary-footerText">
                  No recommended jobs yet
                </div>
              </div>

              {/* Top Institutes Section */}
              <div className="bg-primary-extra rounded-lg shadow-sm p-6">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-lg font-semibold text-primary-text">Top Institute</h3>
                  <button className="text-primary-500 text-sm hover:underline">View All</button>
                </div>
                <div className="text-center py-8 text-primary-footerText">
                  No institutes to show
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Dashboard;